import React, { useEffect, memo } from 'react';
import PropTypes from 'prop-types';

const QUICKFEED_ID = '___quickfeed___';

export const ThumbsUpThumbsDownComponent = ({
    placeholder,
    label,
    environment,
    sourceApplication,
    ...rest
}) => {
    useEffect(() => {
        if (document.getElementById(QUICKFEED_ID)) {
            return;
        }

        const script = document.createElement('script');

        script.type = 'text/javascript';
        script.src = 'https://onegov.nsw.gov.au/quickfeed/js/quickfeed.min.js';
        script.async = true;
        script.defer = true;
        script.id = QUICKFEED_ID;

        script.onload = () => {
            // quickfeed is defined in the global context by this script element loading abd will be present at this point
            // provided the script exists at the given URL

            // eslint-disable-next-line no-undef
            quickFeed.init({
                placeholder,
                label,
                environment,
                sourceApplication,
            });
        };

        document.body.appendChild(script);

        return () => {
            document.body.removeChild(script);
        };
    }, []);

    return (
        <div id={ placeholder } { ...rest } />
    );
};

ThumbsUpThumbsDownComponent.displayName = 'ThumbsUpThumbsDown';

ThumbsUpThumbsDownComponent.propTypes = {
    sourceApplication: PropTypes.string.isRequired,
    placeholder: PropTypes.string,
    label: PropTypes.string,
    environment: PropTypes.string,
};

export const ThumbsUpThumbsDownComponentDefaultProps = {
    placeholder: 'ThumbsUpThumbsDownPlaceholder',
    label: 'How was your experience with us today?',
    environment: 'uat',
};

ThumbsUpThumbsDownComponent.defaultPropse = ThumbsUpThumbsDownComponentDefaultProps;

export const ThumbsUpThumbsDown = memo(ThumbsUpThumbsDownComponent);